module.exports = {
  SELECT_EACH_TIME_INV_TYPE: "S",
  COMMERCIAL: "C",
  PROFORMA: "P",
};
